module.exports = __webpack_public_path__ + "media/331656__trollarch2__keyboard-typing.5b2a60cb.mp4";